module.exports = {
    "wy": "无远社区",
    "admin": "管理员",
    "plate.admin": "版主",
    "bye": "再见 in global",
    "common.confirm": "确定",
    "common.cancel": "取消",
    "common.reply": "评论",
    "common.tip": "提示",
    "common.no.data": "暂无数据",
    "common.markdown": "使用Markdown",
    "common.preview": "预览",
    "common.upload": "上传图片",
    "common.edit": "编辑",
    "common.remove": "删除",
    "just.now": "刚刚",
    "minute.ago": "分钟前",
    "hour.ago": "小时前",
    "day.ago": "天前",
    "month.ago": "个月前",
    "year.ago": "年前",
    "essence": "精华",
    "top": "置顶",
    "untop": "取消置顶",
    "experience": "经验",
    "widget": "组件开发",
    "question": "问题",
    "bug": "Bug",
    "other": "其他",
    "star": "收藏",
    "unstar": "取消收藏",
    "unessence": "取消精华",
    "lock": "冻结帖子",
    "unlock": "取消冻结",
    "praise": "赞",
    "unpraise": "取消赞",
    "collect.topic": "收藏的帖子",
    "topic.type": "请选择帖子类型",
    "tip.title.name.length": "标题必须包含{{min}}-{{max}}个字符",
    "tip.content.length": "内容必须包含{{min}}-{{max}}个字符",
    "fileSize": "文件大小不能超过 1M",
    "uploadFail": "上传图片失败, 请确保单张图片大小不超过 1M",
    "resolved": "已解决",
    "fixed":"已修复",
    "file.size": "文件大小不能超过 {{size}} M",
    "img.tip": "请截图后直接粘贴, 不要先复制图片",
    "answer.topic": "答案被采纳",
    "answered.topic": "答案被采纳的帖子",
    "notice": "公告",
    "requirement": "需求",
    "company": "公司名称",
    "area": "所在区域",
    "desc": "个人描述",
    "website": "个人网站"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.zh-cn.js